import styled from "styled-components";
import { LabelDataHeading, UnderlyingContent, ContentDivider } from '../../style'


export const CardContainer = styled.div`
    background: ${props => props.index === 0 ? props.theme.backgroundColor.cardDark : props.theme.backgroundColor.layoutLight };
    padding: 19px 11px 20px 11px;
`
export const ModelDataHeading = styled(LabelDataHeading)`
margin-right: 5px;
margin-bottom: 15px;
@media only screen and (max-width: 576px){
    font-size: 16px;
    line-height: 1.13;
}
@media only screen and (max-width: 373px){
    font-size: 16px;
    line-height: 1.13;
}   
`

export const UnderlineLinkBold = styled(UnderlyingContent)`
    font-family: ${props =>
    props.theme.fontFamily.helveticaNeueBold};
   // font-weight: bold;
    @media only screen and (max-width: 576px){
        font-size: 16px;
        line-height: 1.13;
    }
    @media only screen and (max-width: 373px){
        font-size: 16px;
        line-height: 1.13;
    }  
`
export const PopupContentDivider = styled(ContentDivider)`
    margin-top: 14px;
    margin-bottom: 10px;
`